<template>
  <div class="list-table">
    <operations-dashboard v-if="isOperations"></operations-dashboard>
    <client-dashboard v-else-if="isClient"></client-dashboard>
    <v-container v-else fluid grid-list-xl>
      <v-layout row wrap v-if="role === 'GEM'">
        <v-flex md6 xs12>
          <v-select
            :items="laboratories"
            label="Filtrar por Laboratorio: "
            no-data-text="Datos no disponibles"
            v-model="labId"
            clearable
          ></v-select>
        </v-flex>
      </v-layout>

      <!-- KPI de tiempos del trámite: días recepción -> entrega por tramo.
           Recarga solo, observando labId. -->
      <kpi-tramite :lab-id="labId"></kpi-tramite>
    </v-container>
  </div>
</template>
<script>
import KpiTramite from './dashboard/KpiTramite'
import SessionHelper from '@/helpers/SessionHelper'
import OperationsDashboard from './dashboard/OperationsDashboard'
import ClientDashboard from './dashboard/ClientDashboard'
export default {
  components: {
    KpiTramite,
    OperationsDashboard,
    ClientDashboard,
  },

  data() {
    return {
      laboratories: [],
      labId: null,
      role: null,
    }
  },
  computed: {
    isClient() {
      return ['DIST', 'LAB'].includes(this.role)
    },
    isOperations() {
      return ['GEM', 'ADM', 'COL'].includes(this.role)
    },
  },
  created() {
    this.role = SessionHelper.role
    if (this.isOperations || this.isClient) return
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })
  },
}
</script>
